import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import {
  faUsers,
  faFolderTree,
  faMobileScreenButton,
  faMicrochip,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Users from "../../components/tabs/Users";
import Files from "../../components/tabs/Files";
import AppVersions from "../../components/tabs/AppVersions";
import FirmwareVersions from "../../components/tabs/FirmwareVersions";
import { useAuthorization } from "../../authorization/useAuthorization";

export default function AdminHome({
  activeKey,
}: {
  activeKey?: "users" | "files" | "app-versions" | "firmware-versions";
}) {
  const auth = useAuthorization({ userTypes: ["Admin", "User"] });
  const isAdmin = auth.authorized && auth.userType === "Admin";

  const navigate = useNavigate();
  useEffect(() => {
    if (auth.authorized) {
      if (!isAdmin) {
        if (!activeKey || activeKey === "users" || activeKey === "files") {
          navigate("/admin-home/app-versions");
        }
      } else if (!activeKey) {
        navigate("/admin-home/users");
      }
    }
  }, [activeKey, auth, navigate, isAdmin]);

  if (!auth.authorized || !activeKey) {
    return <></>;
  }
  const token = auth.token;

  return (
    <>
      <div className="App my-md-3 my-1">
        <div style={{ flex: "auto" }}>
          <Tabs
            activeKey={activeKey}
            id="fill-tab-example"
            fill
            onSelect={(k) => navigate(`/admin-home/${k}`)}
            mountOnEnter
          >
            {isAdmin ? (
              <Tab
                eventKey="users"
                className="m-md-3 m-0"
                title={
                  <span>
                    <FontAwesomeIcon icon={faUsers} className="me-2" /> Users
                  </span>
                }
              >
                {token && <Users token={token} />}
              </Tab>
            ) : null}
            {isAdmin ? (
              <Tab
                eventKey="files"
                className="m-md-3 m-0"
                title={
                  <span>
                    <FontAwesomeIcon icon={faFolderTree} className="me-2" />{" "}
                    Library Files
                  </span>
                }
              >
                {token && <Files token={token} />}
              </Tab>
            ) : null}
            <Tab
              eventKey="app-versions"
              className="m-md-3 m-0"
              title={
                <span>
                  <FontAwesomeIcon
                    icon={faMobileScreenButton}
                    className="me-2"
                  />{" "}
                  App Versions
                </span>
              }
            >
              {token && <AppVersions token={token} isAdmin={isAdmin} />}
            </Tab>
            <Tab
              eventKey="firmware-versions"
              className="m-md-3 m-0"
              title={
                <span>
                  <FontAwesomeIcon icon={faMicrochip} className="me-2" />{" "}
                  Firmware
                </span>
              }
            >
              {token && <FirmwareVersions token={token} isAdmin={isAdmin} />}
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
}
